import React, { useRef, useEffect, useState, useCallback } from 'react';
import { IconClose16, IconImage24, IconGrid24 } from '@fabric-ds/icons/react';
import FocusLock from 'react-focus-lock';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var classes$3 = {"body-scroll-lock":"Lightbox-module_body-scroll-lock__7tY4E","backdrop":"Lightbox-module_backdrop__S-yIz","lightBoxExplanation":"Lightbox-module_lightBoxExplanation__mc6t3"};

var Lightbox = props => {
  var {
    children,
    imageCount,
    mobile
  } = props;
  var contentRef = useRef(null);
  useEffect(() => {
    document.body.classList.add(classes$3['body-scroll-lock'], classes$3['backdrop']);
    return () => document.body.classList.remove(classes$3['body-scroll-lock'], classes$3['backdrop']);
  }, []);
  var backdropClassName = "".concat(classes$3['backdrop'], " fixed flex h-full items-center inset-0 place-content-center place-items-center z-20 p-10");
  return /*#__PURE__*/React.createElement(FocusLock, null, /*#__PURE__*/React.createElement("div", {
    ref: contentRef,
    className: backdropClassName,
    "aria-modal": "true",
    role: "dialog"
  }, children, !mobile && /*#__PURE__*/React.createElement("p", {
    className: "".concat(classes$3.lightBoxExplanation, " hidden lg:block text-white bg-black absolute bottom-0 my-0 p-8")
  }, imageCount > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, "Trykk", ' ', /*#__PURE__*/React.createElement("kbd", {
    className: "border py-2 px-6 rounded-8 "
  }, "Space"), ' ', "for \xE5 veksle mellom oversikt og store bilder.", ' '), /*#__PURE__*/React.createElement("kbd", {
    className: "border py-2 px-6 rounded-8 ",
    "aria-label": "Pil venstre"
  }, "\u2190"), ' ', /*#__PURE__*/React.createElement("kbd", {
    className: "border py-2 px-6 rounded-8 ",
    "aria-label": "Pil h\xF8yre"
  }, "\u2192"), ' ', "for \xE5 bla, og ", /*#__PURE__*/React.createElement("kbd", null, "Esc"), " for \xE5 lukke")));
};

var classes$2 = {"carousel":"MainCarousel-module_carousel__AZmA0","carousel-item":"MainCarousel-module_carousel-item__4DyoX","image-description":"MainCarousel-module_image-description__1SSwT","button-left-container":"MainCarousel-module_button-left-container__1a7Ae","button-right-container":"MainCarousel-module_button-right-container__I048P","button-left":"MainCarousel-module_button-left__hewJM","button-right":"MainCarousel-module_button-right__hZC27","img-with-blur":"MainCarousel-module_img-with-blur__BlTU3","ul-no-filter":"MainCarousel-module_ul-no-filter__-Mkgs"};

var LeftIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  className: "blockify lightbox-arrow-icon inline",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M15 19.5 7.5 12 15 4.5",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var RightIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  fill: "none",
  className: "blockify lightbox-arrow-icon inline",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "m9 4.5 7.5 7.5L9 19.5",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

var throttle = function throttle(callback, timeoutMs) {
  var leading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var currentValue = null;
  var interval;
  var cancel = () => {
    if (interval) {
      clearInterval(interval);
      currentValue = null;
      interval = null;
    }
  };
  return [function () {
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    if (leading && !interval) {
      callback(...values);
    }
    if (!interval) {
      interval = window.setInterval(() => {
        if (currentValue && currentValue !== values) {
          callback(...currentValue);
          currentValue = null;
        } else {
          cancel();
        }
      }, timeoutMs);
    }
    currentValue = values;
  }, cancel];
};
var debounce = (callback, timeoutMs) => {
  var timeoutRef = null;
  var cancel = () => {
    if (timeoutRef) {
      clearTimeout(timeoutRef);
      timeoutRef = null;
    }
  };
  return [function () {
    for (var _len2 = arguments.length, values = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      values[_key2] = arguments[_key2];
    }
    if (timeoutRef) {
      clearTimeout(timeoutRef);
    }
    timeoutRef = window.setTimeout(() => {
      callback(...values);
      timeoutRef = null;
    }, timeoutMs);
  }, cancel];
};
var mod = (current, count) => (current % count + count) % count;
var generateSrcSet = image => {
  var sizes = ['1600w', '1280w', '960w', '640w', '320w', '142w'];
  return sizes.map(size => image.replaceAll('default', size) + ' ' + size).join(',');
};
var getLowResImageUrl = image => image.replaceAll('default', '142w');
var getImage = number => document.getElementById("image-".concat(number));
var loadImage = number => {
  var _getImage, _getImage$getAttribut, _getImage2;
  return (_getImage = getImage(number)) === null || _getImage === void 0 ? void 0 : _getImage.setAttribute('srcset', (_getImage$getAttribut = (_getImage2 = getImage(number)) === null || _getImage2 === void 0 ? void 0 : _getImage2.getAttribute('data-srcset')) !== null && _getImage$getAttribut !== void 0 ? _getImage$getAttribut : '');
};

var MainCarousel = props => {
  var _images$currentImage, _images$currentImage2;
  var {
    currentImage,
    images,
    nextImage,
    previousImage,
    lightboxState,
    fallbackUrl,
    delayF,
    smooth,
    programmaticRatio,
    useBackground
  } = props;
  var totalImages = images.length;
  var initialStyle = {
    aspectRatio: '4 / 3'
  };
  var initialSizes = '(min-width: 1020px) 980px';
  var initialState = {
    sizes: initialSizes,
    ulStyle: initialStyle
  };
  var [state, setState] = useState(initialState);
  var setScrollPosition = currentImage => {
    var _state$listElement;
    if ((_state$listElement = state.listElement) !== null && _state$listElement !== void 0 && _state$listElement.clientWidth) {
      var newPos = (currentImage || 0) * state.listElement.clientWidth;
      if (state.listElement.scrollLeft !== newPos) {
        state.listElement.scrollLeft = (currentImage || 0) * state.listElement.clientWidth;
      }
    }
  };
  var checkScrollPosition = () => {
    var _state$listElement2, _state$listElement$sc;
    if (!((_state$listElement2 = state.listElement) !== null && _state$listElement2 !== void 0 && _state$listElement2.clientWidth)) {
      return;
    }
    var scrollPosition = (_state$listElement$sc = state.listElement.scrollLeft) !== null && _state$listElement$sc !== void 0 ? _state$listElement$sc : 0;
    var currentImage = Math.min(Math.round(scrollPosition / state.listElement.clientWidth), images.length);
    loadImage(currentImage);
    loadImage(currentImage + 1);
    snapChecker(currentImage, state.listElement, setScrollPosition);
    delayF(currentImage);
  };
  useEffect(() => {
    var listener = () => {
      setScrollPosition(currentImage);
    };
    window.addEventListener('resize', listener);
    return () => {
      window.removeEventListener('resize', listener);
    };
  }, [state.listElement, currentImage]);
  useEffect(() => {
    var _state$listElement3;
    if ((_state$listElement3 = state.listElement) !== null && _state$listElement3 !== void 0 && _state$listElement3.clientWidth) {
      function notScrolling() {
        var clientWidth = state.listElement.clientWidth;
        var close = state.listElement.scrollLeft % clientWidth;
        // Width is typically 984, but sometimes it becomes a decimal such as
        // 983.4583211 or 0.359382 (after mod). So we need to compare these
        // to the width and 0.
        return Math.ceil(close) === clientWidth || Math.floor(close) === 0;
      }
      if (smooth !== 'smooth' || notScrolling()) {
        setScrollPosition(currentImage);
      }
      var styleChange = undefined;
      var [sizes, styles] = lightboxState === 'big-image' ? ['', {
        /* Allow to take full height, minus size of top (36px), minus size of info at bottom (38px).*/
        maxHeight: 'calc(100vh - 74px)'
      }] : [initialSizes, initialStyle];
      if (programmaticRatio) {
        styleChange = {
          // aspectRatio: '4 / 3' is 3/4 = 0.75
          height: "".concat(state.listElement.clientWidth * 0.75, "px")
        };
      }
      setState(s => _objectSpread2(_objectSpread2({}, s), {}, {
        ulStyle: _objectSpread2(_objectSpread2({}, styles), styleChange),
        sizes: sizes
      }));
    }
  }, [lightboxState, currentImage, state.listElement]);
  var callbackRef = useCallback(callbackElement => {
    setState(s => _objectSpread2(_objectSpread2({}, s), {}, {
      listElement: callbackElement
    }));
  }, [lightboxState]);
  useEffect(() => {
    loadImage(mod(currentImage, totalImages));
    loadImage(mod(currentImage + 1, totalImages));
    if (currentImage !== 0) {
      loadImage(mod(currentImage + 2, totalImages));
    }
    loadImage(mod(currentImage - 1, totalImages));
  }, [currentImage]);
  var scrollStyle = props.smooth === 'no-scroll' ? 'overflow-x-hidden' : 'overflow-x-auto';
  var ulStyles = state.ulStyle;
  var buttons = images.length > 1 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes$2['button-left-container'],
    onClick: previousImage
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Vis forrige bilde",
    className: classes$2['button-left'],
    onClick: previousImage
  }, /*#__PURE__*/React.createElement(LeftIcon, null))), /*#__PURE__*/React.createElement("div", {
    className: classes$2['button-right-container'],
    onClick: nextImage
  }, /*#__PURE__*/React.createElement("button", {
    "aria-label": "Vis neste bilde",
    className: classes$2['button-right'],
    onClick: nextImage
  }, /*#__PURE__*/React.createElement(RightIcon, null)))) : null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("a", {
    href: fallbackUrl,
    "aria-live": "polite",
    "aria-label": "".concat(((_images$currentImage = images[currentImage]) === null || _images$currentImage === void 0 ? void 0 : _images$currentImage.description) || '', ". Bilde ").concat(currentImage + 1, " av ").concat(totalImages),
    onClick: e => e.preventDefault()
  }, /*#__PURE__*/React.createElement("ul", {
    tabIndex: -1,
    className: "".concat(classes$2['carousel'], " ").concat(scrollStyle, " ").concat(useBackground && lightboxState === 'closed' ? classes$2['ul-no-filter'] : '', " flex overscroll-x-contain overflow-y-hidden w-full mb-0 "),
    style: ulStyles,
    ref: callbackRef,
    id: "main-carousel",
    onScroll: checkScrollPosition
  }, images.map((image, index) => /*#__PURE__*/React.createElement("li", {
    className: "".concat(classes$2['carousel-item'], " flex-shrink-0 w-full flex justify-center"),
    key: "main-image-".concat(index),
    style: useBackground && lightboxState === 'closed' && index - currentImage < 3 ? {
      backgroundImage: "url(".concat(getLowResImageUrl(image.uri), ")"),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover'
    } : {}
  }, /*#__PURE__*/React.createElement("img", {
    "aria-hidden": "true",
    className: "max-h-full max-w-full w-full object-contain object-center ".concat(useBackground && lightboxState === 'closed' ? classes$2['img-with-blur'] : ''),
    title: image.description || '',
    id: "image-".concat(index),
    sizes: state.sizes,
    srcSet: index === currentImage ? generateSrcSet(image.uri) : undefined,
    "data-srcset": generateSrcSet(image.uri),
    alt: "Galleribilde"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "absolute flex justify-center bottom-0 left-0 right-0 mx-10 text-center sm:bottom-32"
  }, /*#__PURE__*/React.createElement("div", {
    "aria-hidden": "true",
    className: "".concat(classes$2['image-description'], " max-w-full rounded-8 p-8 flex text-white ")
  }, /*#__PURE__*/React.createElement("span", {
    className: lightboxState === 'closed' ? 'truncate' : ''
  }, (_images$currentImage2 = images[currentImage]) === null || _images$currentImage2 === void 0 ? void 0 : _images$currentImage2.description), /*#__PURE__*/React.createElement("span", null, "\xA0(", currentImage + 1, "/", totalImages, ")")))), buttons);
};
var checkSnapPos = (currentImage, listElement, setScrollPosition) => {
  var outOfSync = listElement.scrollLeft % listElement.clientWidth !== 0;
  if (outOfSync) {
    setScrollPosition(currentImage);
  }
};
var [snapChecker] = debounce(checkSnapPos, 1200);

var classes$1 = {"overviewImage":"ImagesOverview-module_overviewImage__-Nsik"};

var ImagesOverview = props => {
  var {
    images,
    onClick: _onClick,
    selectedImage
  } = props;
  var imageRefs = useRef([]);
  useEffect(() => {
    var _imageRefs$current$se;
    (_imageRefs$current$se = imageRefs.current[selectedImage]) === null || _imageRefs$current$se === void 0 ? void 0 : _imageRefs$current$se.focus();
  }, [selectedImage]);
  var imageSize = props.images.length;
  var gridCols = "grid-cols-".concat(imageSize > 3 ? 3 : imageSize, " sm:grid-cols-").concat(imageSize > 4 ? 4 : imageSize, " md:grid-cols-").concat(imageSize > 6 ? 6 : imageSize, " lg:grid-cols-").concat(imageSize > 8 ? 8 : imageSize);
  return /*#__PURE__*/React.createElement("div", {
    className: "h-full overflow-y-auto flex flex-col items-center w-full mx-auto",
    style: {
      maxWidth: '2048px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "images-overview-grid",
    className: "grid ".concat(gridCols, " gap-6 p-2 w-full my-auto")
  }, React.Children.toArray(images.map((image, idx) =>
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  React.createElement("a", {
    key: "overview-image-".concat(idx),
    tabIndex: 0,
    ref: r => {
      if (r) {
        imageRefs.current[idx] = r;
      }
    },
    className: "aspect-w-4 aspect-h-3 ".concat(classes$1.overviewImage),
    onClick: e => _onClick(e, idx)
  }, /*#__PURE__*/React.createElement("img", {
    className: "object-cover w-full",
    style: {
      aspectRatio: '4/3'
    },
    src: image.uri,
    alt: "Galleribilde",
    srcSet: generateSrcSet(image.uri),
    sizes: "(max-width: 2500px) 141px, 319px",
    title: "".concat(image.description || '', ", bilde ").concat(idx + 1, " av ").concat(imageSize),
    loading: "lazy"
  }))))));
};

var classes = {"emptyContainer":"ImageGallery-module_emptyContainer__s9Dup","emptyImage":"ImageGallery-module_emptyImage__H8Quc","containerWithBorder":"ImageGallery-module_containerWithBorder__OSOSl","fallback":"ImageGallery-module_fallback__JbDLY","working":"ImageGallery-module_working__Laug8"};

var ImageGallery = props => {
  if (props.images.length === 0) {
    return ImageGalleryWithoutContent();
  } else {
    return ImageGalleryWithContent(props);
  }
};
var ImageGalleryWithoutContent = () => {
  return /*#__PURE__*/React.createElement("div", {
    className: "w-full bg-aqua-50 relative ".concat(classes.emptyContainer)
  }, /*#__PURE__*/React.createElement("img", {
    className: classes.emptyImage,
    alt: "Mangler bilder",
    src: "https://static.finncdn.no/_c/mfinn/static/images/no-image-text.642b3397.svg"
  }));
};
var ImageGalleryWithContent = props => {
  var {
    images,
    smoothOverride,
    initialImage,
    programmaticRatioOverride,
    trackLightBox,
    trackNavigation,
    fallbackUrl,
    onChange,
    useBackground
  } = props;
  var [state, setState] = useState({
    lightboxState: 'closed',
    currentImage: initialImage && Math.min(initialImage, images.length - 1) || 0,
    smooth: smoothOverride !== undefined ? smoothOverride : 'throttled',
    programmaticRatio: programmaticRatioOverride || false
  });
  // send events up
  useEffect(() => {
    onChange && onChange(state.lightboxState);
  }, [state, onChange]);
  var imageCount = images.length;
  var [_delayF, cancelDelayF] = state.smooth === 'smooth' ? [throttleCurrent, cancelThrottle] : [debounceCurrent, cancelDebounce];
  useEffect(() => {
    if (!smoothOverride && !programmaticRatioOverride) {
      var programmaticRatio = false;
      var smooth = state.smooth;
      try {
        // Relatively new css prop. Does not work in Safari < 15
        if (!CSS.supports('aspect-ratio', 'auto')) {
          programmaticRatio = true;
        }
        // On Android, the snapping of css works with varying degree, but it is certainly safer just to
        // turn it off. Since we are defaulting to throttle, we could allow it...
        /*
        if (
            navigator.userAgent.toLowerCase().indexOf('android') !== -1
        ) {
            smooth = 'no-scroll';
        }*/
      } catch (e) {
        // Shouldn't happen, but...
        console.error('Error in feature detection', e);
        smooth = 'no-scroll';
        programmaticRatio = true;
      }
      setState(s => _objectSpread2(_objectSpread2({}, s), {}, {
        smooth,
        programmaticRatio
      }));
    }
  }, []);
  useEffect(() => {
    var listener = handlePagingKeyDown(_delayF, cancelDelayF, state, setState, imageCount);
    document.addEventListener('keydown', listener);
    return () => {
      document.removeEventListener('keydown', listener);
    };
  }, [state.currentImage, state.lightboxState]);
  var mainCarousel = /*#__PURE__*/React.createElement(MainCarousel, {
    images: images,
    currentImage: state.currentImage,
    nextImage: nextImage(_delayF, state, setState, imageCount, trackNavigation),
    previousImage: previousImage(_delayF, state, setState, imageCount, trackNavigation),
    smooth: state.smooth,
    fallbackUrl: state.lightboxState === 'closed' ? fallbackUrl : undefined,
    programmaticRatioOverride: programmaticRatioOverride,
    delayF: currentImg => _delayF(currentImg, c => updateCurrentImg(setState)(c)),
    lightboxState: state.lightboxState,
    programmaticRatio: state.programmaticRatio,
    useBackground: useBackground
  });
  var closeButton = /*#__PURE__*/React.createElement("button", {
    "aria-label": "Lukk store bilder",
    className: "mt-8 text-white",
    onClick: toggleLightbox(cancelDelayF, state, setState)
  }, /*#__PURE__*/React.createElement(IconClose16, {
    height: "24px",
    width: "24px"
  }));
  var content;
  var toggleButton = (text, imageCount) => imageCount > 1 ? /*#__PURE__*/React.createElement("button", {
    className: "mt-8 text-white flex gap-10 items-center",
    onClick: toggleOverView(setState)
  }, text === 'Store bilder' ? /*#__PURE__*/React.createElement(IconImage24, null) : /*#__PURE__*/React.createElement(IconGrid24, null), text) : /*#__PURE__*/React.createElement("span", null);
  if (state.lightboxState === 'closed') {
    var firstImg = images[0];
    content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.working, " cursor-pointer relative ").concat(useBackground ? classes.containerWithBorder : ''),
      style: {
        maxHeight: '1000px'
      },
      "data-testid": "gallery-main",
      onClick: clickPhoto(_delayF, cancelDelayF, state, setState, imageCount)
    }, mainCarousel), /*#__PURE__*/React.createElement("div", {
      className: "".concat(classes.fallback, " flex-col")
    }, /*#__PURE__*/React.createElement("img", {
      className: "object-cover object-center",
      src: firstImg.uri,
      srcSet: generateSrcSet(firstImg.uri),
      sizes: "(min-width: 1020px) 980px",
      title: firstImg.description || '',
      loading: "lazy"
    }), fallbackUrl && /*#__PURE__*/React.createElement("span", null, "Du bruker en gammel nettleser, som ikke st\xF8tter denne bildevisningen. Du kan se alle bildene i\xA0", /*#__PURE__*/React.createElement("a", {
      href: fallbackUrl
    }, "bildegalleriet"), ".")));
  } else if (state.lightboxState === 'big-image') {
    trackLightBox && trackLightBox();
    content = /*#__PURE__*/React.createElement(Lightbox, {
      imageCount: imageCount
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full h-full flex flex-col",
      style: {
        backgroundColor: 'unset'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between mb-4"
    }, toggleButton('Bildeoversikt', imageCount), closeButton), /*#__PURE__*/React.createElement("div", {
      className: "cursor-pointer w-full m-auto",
      style: {
        maxWidth: '1600px'
      },
      onClick: clickPhoto(_delayF, cancelDelayF, state, setState, imageCount)
    }, mainCarousel)));
  } else {
    content = /*#__PURE__*/React.createElement(Lightbox, {
      imageCount: imageCount
    }, /*#__PURE__*/React.createElement("div", {
      className: "w-full h-full",
      style: {
        backgroundColor: 'unset'
      }
    }, /*#__PURE__*/React.createElement("div", {
      className: "flex justify-between"
    }, toggleButton('Store bilder', imageCount), closeButton), /*#__PURE__*/React.createElement(ImagesOverview, {
      images: images,
      onClick: handlePreviewClick(_delayF, setState),
      selectedImage: state.currentImage
    })));
  }
  return content;
};
var updateCurrentImg = setState => currentImage => {
  updateSearchParams(currentImage);
  setState(s => _objectSpread2(_objectSpread2({}, s), {}, {
    currentImage
  }));
};
var setImageRow = (state, setState, imageCount, plusOrMinus) => {
  var container = document.getElementById('images-overview-grid');
  if (container) {
    var colSize = getComputedStyle(container).getPropertyValue('grid-template-columns').split(' ').length;
    var wantedImage = state.currentImage + colSize * plusOrMinus;
    var calculatedImage;
    if (wantedImage >= imageCount) {
      // Puts in same position on first row
      calculatedImage = wantedImage % colSize;
    } else if (wantedImage < 0) {
      var rowSize = getComputedStyle(container).getPropertyValue('grid-template-rows').split(' ').length;
      var endPos = (rowSize - 1) * colSize + state.currentImage;
      if (endPos >= imageCount) {
        calculatedImage = endPos - colSize;
      } else {
        calculatedImage = endPos;
      }
    } else {
      calculatedImage = wantedImage;
    }
    setState(s => _objectSpread2(_objectSpread2({}, s), {}, {
      currentImage: calculatedImage
    }));
  }
};
var handlePagingKeyDown = (delayF, cancelDelayF, state, setState, imageCount) => event => {
  if (event.code === 'ArrowRight' && !event.altKey && !event.metaKey && !event.ctrlKey) {
    nextImage(delayF, state, setState, imageCount)();
  }
  if (event.code === 'ArrowLeft' && !event.altKey && !event.metaKey && !event.ctrlKey) {
    previousImage(delayF, state, setState, imageCount)();
  }
  if (state.lightboxState === 'overview') {
    if (event.code === 'ArrowDown') {
      setImageRow(state, setState, imageCount, 1);
    } else if (event.code === 'ArrowUp') {
      setImageRow(state, setState, imageCount, -1);
    }
  }
  if (event.code === 'Escape' && state.lightboxState !== 'closed') {
    toggleLightbox(cancelDelayF, state, setState)();
  }
  if (event.code === 'Space' && state.lightboxState !== 'closed' && imageCount > 1) {
    // prevents scrolling
    event.preventDefault();
    toggleOverView(setState)();
  }
  if (event.code === 'Enter' && state.lightboxState === 'overview') {
    // prevents scrolling
    event.preventDefault();
    toggleOverView(setState)();
  }
};
var [debouncedReplaceHistory] = debounce(currentImage => {
  var searchParams = new URLSearchParams(window.location.search);
  if (currentImage === 0) {
    searchParams.delete('ci');
  } else {
    searchParams.set('ci', (currentImage + 1).toString());
  }
  window.history.replaceState({}, '', window.location.pathname + '?' + searchParams.toString());
}, 500);
var updateSearchParams = currentImage => {
  debouncedReplaceHistory(currentImage);
};
var nextImage = (delayF, state, setState, imageCount, trackNavigation) => e => {
  preventDefaults(e);
  trackNavigation && trackNavigation();
  var nextImg = mod(state.currentImage + 1, imageCount);
  delayF(nextImg, i => updateCurrentImg(setState)(i));
};
var previousImage = (delayF, state, setState, imageCount, trackNavigation) => function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  preventDefaults(e);
  trackNavigation && trackNavigation();
  var prevImag = mod(state.currentImage - 1, imageCount);
  delayF(prevImag, i => updateCurrentImg(setState)(i));
};
var toggleLightbox = (cancelDelayF, state, setState) => function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  preventDefaults(e);
  cancelDelayF();
  setState(s => _objectSpread2(_objectSpread2({}, s), {}, {
    lightboxState: s.lightboxState === 'closed' ? 'big-image' : 'closed'
  }));
};
var clickPhoto = (delayF, cancelDelayF, state, setState, imageCount) => () => {
  if (state.lightboxState !== 'closed') {
    nextImage(delayF, state, setState, imageCount)();
  } else {
    toggleLightbox(cancelDelayF, state, setState)();
  }
};
var toggleOverView = setState => function () {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
  preventDefaults(e);
  setState(s => _objectSpread2(_objectSpread2({}, s), {}, {
    lightboxState: s.lightboxState === 'overview' ? 'big-image' : 'overview'
  }));
};
var handlePreviewClick = (delayF, setState) => (e, page) => {
  preventDefaults(e);
  setState(s => _objectSpread2(_objectSpread2({}, s), {}, {
    lightboxState: 'big-image',
    currentImage: page
  }));
};
var setCurrentImage = (currentImage, setCurrentImage) => {
  setCurrentImage(currentImage);
};
var [throttleCurrent, cancelThrottle] = throttle(setCurrentImage, 200, true);
var [debounceCurrent, cancelDebounce] = debounce(setCurrentImage, 50);
var getCurrentImageFromSearchParams = searchParams => {
  try {
    return parseInt(searchParams.get('ci') || '1') - 1;
  } catch (e) {
    return 0;
  }
};
var preventDefaults = e => {
  e === null || e === void 0 ? void 0 : e.stopPropagation();
  e === null || e === void 0 ? void 0 : e.preventDefault();
};

export { ImageGallery, getCurrentImageFromSearchParams };
//# sourceMappingURL=index.js.map
